import AuthDrawer from "../../components/AuthDrawer";
import {useHistory, useParams} from "react-router-dom";
import {Box, Divider, FormControl, MenuItem, Select, Stack, TextField, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import useCallDataApi from "../../hooks/data";
import {useEffect, useState} from "react";
import Loading from "../../components/Loading";
import DinoDataGrid from "../../components/DataGrid";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {hu} from "date-fns/locale";
import {format} from "date-fns";
import thousandSeparator from "../../utils/NumberUtils";
import MyPieChart from "../employee/PieChart";
import MonthlyPartnerBarChart from "./MonthlyPartnerBarChart";
import {getYears} from "../../utils/miscUtils";
import CompanyDetailSummary from "../../components/CompanyDetailSummary";


const PartnerEffectivenessDetail = () => {
    const today = new Date()
    const queryParams = JSON.parse(localStorage.getItem('partnerQuery') || "{}")
    const {getData: fetchPartners, postData: postPartners} = useCallDataApi('partners')
    const [partner, setPartner] = useState({})
    const [chartTrafficData, setChartTrafficData] = useState([])
    const [chartMarginData, setChartMarginData] = useState([])
    const [chartItemData, setChartItemData] = useState([])
    const [partnerData, setPartnerData] = useState([])
    const [partnerDataTest, setPartnerDataTest] = useState([])
    const [monthly, setMonthly] = useState([])
    const [fromDate, setFromDate] = useState(new Date(queryParams?.start_date || `${today.getFullYear()}-01-01`))
    const [endDate, setEndDate] = useState(new Date(queryParams?.end_date || today))
    const [selectedYear, setSelectedYear] = useState(today.getFullYear())
    const [loading, setLoading] = useState({
        partner: false,
        partnerData: false,
        partnerDataTest: false,
        chartData: false,
    });
    const params = useParams()
    const history = useHistory()

    document.title = partner.uf_name

    useEffect(() => {
        setLoading(prev => ({...prev, partner: true}));
        fetchPartners(`${params.id}/`)
            .then(p => setPartner(p))
            .finally(() => setLoading(prev => ({...prev, partner: false})));
    }, [params.id]);

    useEffect(() => {
        setLoading(prev => ({...prev, partnerData: true}));
        postPartners('partner_data_for_range/', {
            partner: params.id,
            start_date: format(fromDate, 'yyyy-MM-dd'),
            end_date: format(endDate, 'yyyy-MM-dd'),
        })
            .then(d => setPartnerData(d))
            .finally(() => setLoading(prev => ({...prev, partnerData: false})));
        postPartners('partner_data_for_range_test_function/', {
            partner: params.id,
            start_date: format(fromDate, 'yyyy-MM-dd'),
            end_date: format(endDate, 'yyyy-MM-dd'),
        })
            .then(d => setPartnerDataTest(d))
            .finally(() => setLoading(prev => ({...prev, partnerDataTest: false})));
    }, [params.id, fromDate, endDate]);

    useEffect(() => {
        setLoading(prev => ({...prev, chartData: true}));
        Promise.all([
            postPartners('monthly_partner_data_for_year/', {
                partner: params.id,
                year: selectedYear,
            }).then(d => setMonthly(d)),
            postPartners('partner_traffic_by_controlling_groups/', {
                year: selectedYear,
                partner: params.id,
            }).then(p => setChartTrafficData(p)),
            postPartners('partner_margin_by_controlling_groups/', {
                year: selectedYear,
                partner: params.id,
            }).then(p => setChartMarginData(p)),
            postPartners('partner_item_by_controlling_groups/', {
                year: selectedYear,
                partner: params.id,
            }).then(p => setChartItemData(p)),
        ])
            .finally(() => setLoading(prev => ({...prev, chartData: false})));
    }, [params.id, selectedYear]);

    const columns = [
        {headerName: 'Tétel megnevezése', field: 'mirr_name1', width: 300},
        {
            headerName: 'Forgalom',
            field: 'total_sum_traffic',
            width: 300,
            renderCell: p => `${thousandSeparator(p.row.total_sum_traffic)} Ft`
        },
        {
            headerName: 'Árrés',
            field: 'total_sum_margin',
            width: 300,
            renderCell: p => `${thousandSeparator(p.row.total_sum_margin)} Ft`
        },
        {
            headerName: 'Darabszám',
            field: 'total_sum_items',
            width: 300,
            renderCell: p => `${thousandSeparator(p.row.total_sum_items)} db`
        },
    ]
    const columnsTest = [
        {headerName: 'sorazon', field: 'sorazon', width: 300},
        {headerName: 'UGYFEL_NEV', field: 'UGYFEL_NEV', width: 300},
        {headerName: 'TELJDAT', field: 'TELJDAT', width: 300},
        {headerName: 'MUNKASZAM', field: 'MUNKASZAM', width: 300},
        {headerName: 'mirr_type', field: 'mirr_type', width: 300},
        {headerName: 'mirr_code', field: 'mirr_code', width: 300},
        {headerName: 'K_OSSZ', field: 'K_OSSZ', width: 300},
        {headerName: 'T_OSSZ', field: 'T_OSSZ', width: 300},
    ]


    return <AuthDrawer label={partner.uf_name}>
        <Stack direction='row'>
            <Button
                variant='outlined'
                startIcon={<ArrowBackIosNewRoundedIcon/>}
                onClick={() => history.goBack()}>
                Vissza
            </Button>
        </Stack>
        <CompanyDetailSummary partnerData={partnerData}/>
        <Box sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 2,
            gap: 3,
            marginTop: 3
        }}>
            <Box sx={{
                display: 'flex',
                gap: 3,
            }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={hu}>
                    <Stack spacing={2} direction='row' alignItems='center'>
                        <DatePicker
                            inputFormat="yyyy-MM-dd"
                            mask='____-__-__'
                            value={fromDate}
                            onChange={(v) => setFromDate(v)}
                            renderInput={(params) => <TextField name='from_date' {...params} />}
                        />
                        <Typography variant='body1' color='#38556A'>-</Typography>
                        <DatePicker
                            inputFormat="yyyy-MM-dd"
                            mask='____-__-__'
                            value={endDate}
                            onChange={(v) => setEndDate(v)}
                            renderInput={(params) => <TextField name='until_date' {...params} />}
                        />
                    </Stack>
                </LocalizationProvider>
            </Box>
        </Box>
        <DinoDataGrid rows={partnerData} columns={columns}/>
        <DinoDataGrid rows={partnerDataTest} columns={columnsTest} getRowId={r => r.sorazon}/>
        <Divider sx={{marginTop: 3}}/>
        <Box sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 2,
            gap: 3,
            marginTop: 3
        }}>
            <Box sx={{
                display: 'flex',
                gap: 3,
            }}>
                <FormControl>
                    <Select
                        id="margin-traffic-select"
                        value={selectedYear}
                        onChange={e => setSelectedYear(e.target.value)}
                    >
                        {getYears().map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                    </Select>
                </FormControl>
            </Box>
        </Box>
        {/*<Box className="white-card" marginTop={2}>*/}
        {/*    <Typography variant='headline6'>Havi bontás</Typography>*/}
        {/*    <MonthlyPartnerBarChart data={monthly}/>*/}
        {/*</Box>*/}
        <Box className="white-card" marginTop={2}>
            <Typography variant='headline6'>Csoportos forgalom bontás</Typography>
            <MyPieChart data={chartTrafficData}/>
        </Box>
        <Box className="white-card" marginTop={2}>
            <Typography variant='headline6'>Csoportos árrés bontás</Typography>
            <MyPieChart data={chartMarginData.filter(d => d.value > 0)}/>
            Negatív számok:
            {chartMarginData.filter(d => d.value < 0).map(d => <div key={d.uf_name}>{d.uf_name}: {thousandSeparator(d.value)} Ft</div>)}
        </Box>
        <Box className="white-card" marginTop={2}>
            <Typography variant='headline6'>Csoportos darabszám bontás</Typography>
            <MyPieChart data={chartItemData} unit='db'/>
        </Box>

        <Loading isLoading={Object.values(loading).some(Boolean)}/>

    </AuthDrawer>
}

export default PartnerEffectivenessDetail